import React from 'react';

interface Props extends React.ComponentProps<'dd'> {}

const DefinitionListDetails: React.FC<Props> = ({
  children,
  ...rest
}) => {
  return (
    <dd {...rest}>
      {children}
    </dd>
  );
};

export default DefinitionListDetails;
